
import { Options, Vue } from "vue-class-component";
import { ToastStore } from "@/store/index";
import { DataStore } from "@/store";
import BusEvent from "../../../../shared/js/BusEvent";

@Options({
  components: {},
  props: {},
})
export default class Toast extends Vue {
  declare $refs: {
    toast: HTMLElement;
  };

  timeoutRef?: number;
  message: string = "";
  toastUnwatch!: Function;

  isOpen(): boolean {
    return this.$refs.toast?.classList.contains("show");
  }

  open(message: string, ms: number = 3000) {
    this.message = message;

    // make sure we reset the timeout timer since it's already open
    if (this.isOpen()) this.clearTimeout();

    this.$refs.toast?.classList.add("show");

    this.timeoutRef = setTimeout(() => {
      this.timeoutRef = undefined;
      this.close();
    }, ms);
  }

  action()
  {

    let strCurrentAction = DataStore.otherThemesAction;

    let strEvent = strCurrentAction === "themes" ? BusEvent.EVENTS.SHOW_OTHER_THEMES : BusEvent.EVENTS.FINISH_EXPERIENCE

      const eventThemeSet = new BusEvent(strEvent);
      document.dispatchEvent(eventThemeSet);

      const eventSound = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {
        key:   "VM_D_1_",
        loop:  false,
        group: "UI"
      });
      document.dispatchEvent(eventSound);

      if (strCurrentAction === "end")
      {
          DataStore.setOtherThemesVisibility(false);
      }

  }

  close() {
    this.$refs.toast?.classList.remove("show");
    if (this.timeoutRef) this.clearTimeout();
  }

  private clearTimeout() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = undefined;
  }

  otherThemeLabel ()
  {
    return DataStore.otherThemesLabel;
  }

  mounted() {
    this.toastUnwatch = ToastStore.$watch(
      (module) => {
        return module.opens;
      },
      (value, legacyValue) => {
        const options = ToastStore.options;
        this.open(options.message, options.ms);
      }
    );
  }

  unmounted() {
    if (this.toastUnwatch)
        this.toastUnwatch();
  }
}
